import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthProvider } from './auth-provider';

/**
 * Guard for routes that require authentication.
 * Redirects to /login if user is not authenticated.
 * Public routes (/home, /) are not guarded.
 */
export function authGuard(): boolean {
  const auth = inject(AuthProvider);
  const router = inject(Router);

  if (auth.state().isAuthenticated) {
    return true;
  }

  router.navigateByUrl('/login');
  return false;
}

/**
 * Guard that redirects authenticated users away from public-only routes (e.g. /login).
 */
export function publicGuard(): boolean {
  const auth = inject(AuthProvider);
  const router = inject(Router);

  if (auth.state().isAuthenticated) {
    router.navigateByUrl('/');
    return false;
  }

  return true;
}

